/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 09:25:36
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-29 14:37:34
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {}
})
